import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BotonFlotante.css';

const BotonFlotante = () => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/tickets');
  };

  return (
    <div
      className="boton-flotante"
      onClick={handleClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="icono">
        🎟️
      </div>
      {hover && <div className="texto">¿Necesitas ayuda?</div>}
    </div>
  );
};

export default BotonFlotante;
